import { merge } from 'lodash'
import { BasicConfig } from './basic-config'

export const echartsType = 'Pie'

export class Pie extends BasicConfig {
  constructor(options) {
    super(options)
    this.init(options)
  }
  init(options) {
    const { code } = options
    this.initLegend()
    this.initSeries(options)
    this.initTitle(options)
    this.initTooltip()
    this.option = this.initOption(options)
    this._pieOptions = options
    this.code = code
  }
  initOption(options) {
    const { code } = options
    const { series, color, legend, tooltip, title } = this

    const option = {
      series,
      color,
      legend,
      tooltip,
    }
    if (!code.includes('Bt')) {
      option.title = title
    }
    return option
  }
  initSeries(options) {
    const { commonConfig } = options
    const { series } = commonConfig
    this.series = merge([
      {
        name: 'kye-pie',
        type: 'pie',
        avoidLabelOverlap: true,
        label: {
          show: false,
          position: 'center'
        },
        itemStyle: {
          borderColor: '#fff',
          borderWidth: 1
        },
        data: this.data,
      }
    ], series)
  }
  initLegend() {
    const { legend } = this
    this.legend = {
      ...legend,
      show: false
    }
  }
  initTitle(options) {
    const { commonConfig, summaryData } = options
    const { title } = commonConfig
    this.title = merge([
      {
        text: summaryData.value,
        left: 'center',
        padding: [
          5,
          10,
          0,
          10
        ],
        subtext: summaryData.name,
        textStyle: {
          fontSize: 14,
          fontBold: 'bold',
          color: '#333333'
        },
        subtextStyle: {
          lineHeight: 10,
          color: '#666666'
        }
      },
    ], title)
  }
  initTooltip() {
    const { tooltip } = this
    this.tooltip = {
      ...tooltip,
      className: 'kye-form-echarts_tooltip',
      padding: [0, 0, 11, 0],
      formatter: (param) => {
        return this.createTooltip(param, this._pieOptions)
      }
    }
  }
}

Pie.echartsType = echartsType



// WEBPACK FOOTER //
// ./src/public/components/kye-report-form/echarts/common/basic/pie.js